import React from "react";
import { FieldSet } from "src/components/event_transaction/components/shared/Form/FieldSet";
import { groupOptionScope2 } from "./groupOptionData";

const CheckBoxListsScope2 = (props) => {
  const { control, disabled } = props;

  return (
    <div>
      <FieldSet
        disabled={disabled}
        name="scopes.scope2"
        type="checkbox"
        control={control}
        label="Scope 2"
        subLabel="การใช้พลังงาน"
        groupOptions={groupOptionScope2}
      />
    </div>
  );
};

export default CheckBoxListsScope2;
